import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { News } from '../../model/news.model';
import { ApiService } from '../../services/api.service';
var showdown  = require('showdown');


@Component({
  selector: 'ngx-single-news',
  templateUrl: './single-news.component.html',
  styleUrls: ['./single-news.component.scss']
})
export class SingleNewsComponent implements OnInit {
  private converter = new showdown.Converter();
  public news: News[];
  public date: any;
  public body: any;
  public featuredNews: News[];
  constructor(private router : Router,
              private _apiService: ApiService) { }

  ngOnInit(): void {
    this.getNews(this.router.url);
    this.getFeaturedPosts();
  }

  getNews(url){
    // Cutting the url to get the id of news
    let newsPageId = url.substring(url.lastIndexOf('/') + 1);
    // Filter page and get ONLY the posts that belong to the category thats been sliced from url
    this._apiService.getNews("?filters[id][$eq]="+newsPageId).subscribe((res) => {
      this.news = res['data'];
      this.body = this.converter.makeHtml(res['data'][0]['attributes'].content);
      console.log(this.news);  
    });
    
  }
  getFeaturedPosts(){
    this._apiService.getNews("?filters[isFeatured][$eq]=true").subscribe((res)=> {
      this.featuredNews = res['data'].slice(0,2);
    })
  }
}
